export bootstrap from './bootstrap';
export cleanDir from './cleanDir';
export copyDirs from './copyDirs';
export define from './define';
export manifest from './manifest';
export minify from './minify';
export processEnv from './processEnv';
export scss from './scss';
